import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function AccountLayout({ children }: { children: React.ReactNode }) {
  const { t: tSettings } = useTranslation("settings");

  return (
    <>
      <PageTitle>{tSettings("account")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/account")({
  component: function LayoutRoute() {
    return (
      <AccountLayout>
        <Outlet />
      </AccountLayout>
    );
  },
});
